module.exports = __webpack_public_path__ + "static/media/ic-not-allowed.7c2caa08.svg";